import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var units = {
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024
};
import { getDownloadUrl } from '@/api/common';
export default {
  name: 'UploadFile',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: 'annex'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showTip: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 0
    },
    accept: {
      type: String,
      default: '*'
    },
    buttonText: {
      type: String,
      default: '选择文件'
    },
    sizeUnit: {
      type: String,
      default: 'MB'
    },
    fileSize: {
      default: 5
    }
  },
  data: function data() {
    return {
      fileList: this.value,
      uploadHeaders: {
        Authorization: this.$store.getters.token
      }
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.fileList = val;
      }
    }
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      var unitNum = units[this.sizeUnit];
      if (!this.fileSize) return true;
      var isRightSize = file.size / unitNum < this.fileSize;
      if (!isRightSize) {
        this.$message.error("\u6587\u4EF6\u5927\u5C0F\u8D85\u8FC7".concat(this.fileSize).concat(this.sizeUnit));
      }
      // let isAccept = new RegExp(this.accept).test(file.type)
      // if (!isAccept) {
      //   this.$message.error(`应该选择${this.accept}类型的文件`)
      // }
      return isRightSize;
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.fileList.push({
          name: file.name,
          fileId: res.data.name,
          url: res.data.url
        });
        this.$emit('input', this.fileList);
      } else {
        fileList.filter(function (o) {
          return o.uid != file.uid;
        });
        this.$emit('input', this.fileList);
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1500
        });
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u6700\u591A\u53EF\u4EE5\u4E0A\u4F20".concat(this.limit, "\u4E2A\u6587\u4EF6"));
    },
    handleRemove: function handleRemove(file, index) {
      this.fileList.splice(index, 1);
      this.$refs.elUpload.uploadFiles.splice(index, 1);
      this.$emit("input", this.fileList);
      // this.$confirm(`确定移除${file.name}？`, '提示').then(() => {
      // }).catch(() => { })
    },
    handleClick: function handleClick(file) {
      var _this = this;
      // 点击下载文件
      if (!file.fileId) return;
      getDownloadUrl(this.type, file.fileId).then(function (res) {
        if (res.data.url) window.location.href = _this.define.comUrl + res.data.url;
      });
    }
  }
};